import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../CRE.dtos";
import { fileApi } from "../../services/file.service";

export interface IUploadTemporaryFileProps {
    onUpdated: Function;
}

interface IUploadTemporaryFileState {
    fileName: string;
}

export default class UploadTemporaryFile extends React.Component<IUploadTemporaryFileProps, IUploadTemporaryFileState> {
    constructor(props: IUploadTemporaryFileProps) {
        super(props);
        this.state = {
            fileName: ""
        }
        this.onChanged = this.onChanged.bind(this);
        this.triggerInputFile = this.triggerInputFile.bind(this);
    }

    fileInput: any;

    onChanged(e) {
        let self = this;
        const files = Array.from(e.target.files);
        fileApi.upload(files)
            .then(response => {
                self.props.onUpdated(response.imgPath);
            })
            .catch(e => {
                console.error(e);
            });
        e.target.value = '';
    }

    triggerInputFile = () => this.fileInput.click()


    render() {
        return (
            <div>
                <input ref={fileInput => this.fileInput = fileInput} type="file" className="form-control" id="fileupload" name="fileupload" onChange={this.onChanged} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/UploadTemporaryFile.tsx